<template>
  <div id="app" :class="[isMobile ? {'position-fixed': isNavOpen} : '', {'overflow-hidden' : (!userLoggedIn)}]">
    <header-bar v-model="isNavOpen" :hide-burger-menu="hideBurgerMenu" />

    <div :class="['container-fluid', {'outer-container': userLoggedIn, 'invoices-container': isInvoicesPage, 'dynamic-container': currentPageHasBreakPoints}]">
      <div class="row">
        <div v-if="isNavOpen" class="sidebar-backdrop position-fixed" @click="isNavOpen=false" />
        <transition-expand-side :expand-direction="'expand-side-right'" @after-enter="onSideBarEnter">
          <side-bar-menu v-if="displaySidebar" />
        </transition-expand-side>
        <div v-if="appBusy" class="container-fluid page-container">
          <spinner />
        </div>
        <router-view v-else />
      </div>
    </div>
  </div>
</template>

<script>
import TransitionExpandSide from "@/components/animation/TransitionExpandSide";
import SideBarMenu from "./components/menu/SideBarMenu";
import HeaderBar from "./components/header/HeaderBar";
import {IS_MOBILE, IS_TABLET} from "@/store/mutation-types";
import Spinner from "@/components/animation/Spinner";
import userDevice from "@/imports/mixins/userDevice";
import pageBreakpoints from "@/imports/data/pageBreakpoints.json";
import {LEAD_NOTIFICATION_INTERVAL} from "@/store/leads/mutation-types";
import { setContext } from "@/services/userMonitoring";

const MOBILE_BREAKPOINT = 767;
const TABLET_BREAKPOINT = 1200;

export default {
  components: {
    Spinner,
    HeaderBar,
    SideBarMenu,
    TransitionExpandSide,
  },
  mixins: [userDevice],
  data: function () {
    return {
      currentPageBreakpoints: {},
      currentPageHasBreakPoints: false,
      pageBreakpoints: pageBreakpoints,
      isNavOpen: false,
      isInvoicesPage: false,
      openingFeedback: false,
    }
  },
  computed: {
    userLoggedIn: function () {
      return this.$store.state.USER_STATE;
    },
    appBusy: function () {
      return this.$store.state.BUSY;
    },
    displaySidebar: function() {
      if (this.userLoggedIn) {
        return !this.isMobile && !this.isTablet || this.isNavOpen;
      }
      return false;
    },
    hideBurgerMenu: function() {
      return !this.isTablet;
    },
    leadNotificationInterval: {
      get: function () {
        return this.$store.state.leads.LEAD_NOTIFICATION_INTERVAL;
      },
      set: function (value) {
        this.$store.commit(LEAD_NOTIFICATION_INTERVAL, value);
      }
    },
    company: function() {
      return this.$store.state.company.COMPANY;
    }
  },
  methods: {
    handleResize: function () {
      if (this.currentPageHasBreakPoints) {
        this.$store.commit(IS_MOBILE, window.innerWidth <= this.currentPageBreakpoints.tablet);
        this.$store.commit(IS_TABLET, window.innerWidth <= this.currentPageBreakpoints.desktop && window.innerWidth > this.currentPageBreakpoints.tablet);
      } else {
        this.$store.commit(IS_MOBILE, window.innerWidth <= MOBILE_BREAKPOINT);
        this.$store.commit(IS_TABLET, window.innerWidth <= TABLET_BREAKPOINT && window.innerWidth > MOBILE_BREAKPOINT);
      }
    },
    setCurrentBreakPoints: function() {
      this.currentPageBreakpoints = {...this.pageBreakpoints[this.$router.currentRoute.name]};
      this.currentPageHasBreakPoints = Object.keys(this.currentPageBreakpoints).length !== 0 && this.currentPageBreakpoints.constructor === Object
    },
    pollNotifications: function() {
      if (this.$route.meta.open === false) {
        this.$store.dispatch('getLeadNotifications');
      }
    },
    isInvoiceRoute: function() {
      this.isInvoicesPage = this.$router.currentRoute.name === 'invoices';
    },
    onSideBarEnter: function() {
      if (this.openingFeedback) {
        this.$root.$emit('bv::show::tooltip','feedback-tooltip');
      }
    }
  },
  watch: {
    $route: function () {
      this.setCurrentBreakPoints();
      this.isInvoiceRoute();
      this.isNavOpen = false;
      this.handleResize();
    },
    isNavOpen: function(value) {
      this.$eb.$emit('nav-state', value);
    },
    company: function(value) {
      if (value !== null) {
        setContext({
          company: value.id,
          view: this.isDesktop ? 'desktop' : 'mobile',
        });
      }
    }
  },
  created: function () {
    if (this.leadNotificationInterval) {
      clearInterval(this.notificationInterval);
    }
    this.leadNotificationInterval = setInterval(() => {
      this.pollNotifications();
    }, 60000);

    this.$root.$on('bv::show::tooltip', (state) => {
      if (state === 'feedback-tooltip' && this.isMobile) {
        if (this.openingFeedback) {
          this.openingFeedback = false;
        } else {
          this.openingFeedback = true;
          this.isNavOpen = true;
        }
      }
    });

    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    clearInterval(this.notificationInterval);
    window.removeEventListener('resize', this.handleResize);
  },
}
</script>
<style lang="scss">
  @include media-breakpoint-up(md) {
    .sidebar {
      top: 103px;
      z-index: 2;
    }
  }

  @include media-breakpoint-down(xl) {
    .sidebar-backdrop {
      opacity: 1;
      background: rgba(1, 54, 82, .2);
      top: 0;
      left: 0;
      z-index: 3;
      width: 100vw;
      height: 100vh;
    }
  }
</style>
